/*!
 * dasoertliche-javascript-library-7.26
 * 
 * Copyright (C) 2008-2025 TENSQUARE GmbH. All rights reserved.
 * https://www.tensquare.de
 * Die Inhalte dieser Datei sind urheberrechtlich geschützt. Sie dürfen
 * weder ganz noch in Teilen vervielfältigt, verbreitet oder öffentlich
 * zugänglich gemacht werden. Jegliche Nutzung, sowohl zu privaten als
 * auch zu kommerziellen Zwecken, bedarf der schriftlichen Genehmigung
 * der TENSQUARE GmbH.
 */
if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global, window, document, undefined) {
    var namespace = global.getNamespace("media");
    function PreviewHandler(opts) {
        var self = this, DEFAULT_OPTIONS = {
            expandDelay: 800,
            className: "preview_box",
            previewContainer: "<div></div>",
            onMouseLeave: undefined
        }, options;
        options = global.obj.deepMerge(DEFAULT_OPTIONS, opts || {});
        self.timerId = undefined;
        this.show = function(event, preview, onShowFn, onClickFn) {
            var className = options.className, evtObj = $(event.event.currentTarget);
            self.timerId = window.setTimeout(function(element) {
                $("." + className).remove();
                var $previewContainer = $(options.previewContainer).attr("class", options.className);
                if (preview) {
                    if (global.val.isFunction(onShowFn)) {
                        onShowFn(element);
                    }
                    $(new Image()).on("load", function() {
                        evtObj.append($previewContainer.append(this).on("click", function() {
                            if (global.val.isFunction(onClickFn)) {
                                onClickFn(element);
                            }
                        }));
                        self.timerId = undefined;
                    }).attr({
                        src: preview
                    }).each(function() {
                        if (this.complete) {
                            $(this).trigger("load");
                        }
                    });
                }
            }, options.expandDelay, event);
            if (global.val.isFunction(options.onMouseLeave)) {
                evtObj.on("mouseleave", options.onMouseLeave);
            } else {
                evtObj.on("mouseleave", function() {
                    if (self.timerId) {
                        window.clearTimeout(self.timerId);
                        self.timerId = undefined;
                    }
                    $("." + className).remove();
                });
            }
        };
    }
    namespace.PreviewHandler = PreviewHandler;
})($oe$, this, document);

if (!$oe$ || !$ || !$oe$.ui) {
    throw new Error("Core libs missing");
}

(function(global) {
    var hl = global.getNamespace("hitlist"), win = window, doc = document, SOURCE_HIT = "hit", CONTEXTMENU_EVENT = "contextmenu", CLICK_EVENT = "click", CLICK_AND_CONTEXTMENU_EVENTS = CLICK_EVENT + " " + CONTEXTMENU_EVENT, MOUSEOVER_EVENT = "mouseover", MOUSEOUT_EVENT = "mouseout", MOUSEENTER_EVENT = "mouseenter", MOUSELEAVE_EVENT = "mouseleave", entryHandlerList = [], ITEM_TYPE = {
        ENTRY: "entry",
        CTXENTRY: "ctxentry"
    }, WIPE_TRACKINGNAME = "waName", WIPE_TRACKING = "waTrack", UNKNOWN_CLASS = "unknown", AUTO_POSTFIX = ":add_auto";
    function getEntryId(linkEl) {
        var entryTable = $(linkEl).closest("div.hit");
        if (entryTable.length > 0) {
            return entryTable[0].id;
        } else {
            return undefined;
        }
    }
    function parseEntryElementId(id) {
        var i, idx, result = {};
        if (global.val.isString(id)) {
            i = id.lastIndexOf("_");
            if (i >= 0) {
                result.type = id.substring(0, i);
                idx = global.str.toInt(id.substring(i + 1));
                if (idx > 0) {
                    result.idx = idx;
                }
            }
        }
        return result;
    }
    function EntryHandler(initialOptions) {
        var self = this, items = {}, globalParams = {}, entryLinks, charset, URL_INCLUDE_MACRO_PATTERN = /(^|.|\r|\n)(\$url\{(.*?)\})/, paramCodec, isSEOMode, shortDetailsURLBuilder, wipeTracker, options = global.options && global.options.entryHandler ? global.options.entryHandler.DEFAULT : {}, visLoader, ponyfillHandler;
        function getOptions() {
            return options;
        }
        function setOptions(opt) {
            var linkDef, seoLinkDef;
            if (opt) {
                options = global.obj.deepMerge(options, opt);
            }
            if (global.val.isObject(options.seoLinks) && options.seoLinks.hasOwnProperty("hit") && global.val.isObject(options.links) && options.links.hasOwnProperty("hit")) {
                for (var key in options.seoLinks.hit) {
                    if (options.seoLinks.hit.hasOwnProperty(key) && options.links.hit.hasOwnProperty(key)) {
                        linkDef = options.links.hit[key];
                        seoLinkDef = options.seoLinks.hit[key];
                        if (!seoLinkDef.hasOwnProperty(WIPE_TRACKINGNAME) && linkDef.hasOwnProperty(WIPE_TRACKINGNAME)) {
                            seoLinkDef[WIPE_TRACKINGNAME] = linkDef[WIPE_TRACKINGNAME];
                        }
                    }
                }
            }
        }
        function getItems(itemType) {
            var map;
            if (!itemType) {
                return undefined;
            }
            map = items[itemType];
            if (!map) {
                map = items[itemType] = [];
            }
            return map;
        }
        function addItem(itemType, item) {
            if (!isSupportedItemType(itemType)) {
                global.log("addItem. Unsupported item type: " + itemType);
                return self;
            }
            var list = getItems(itemType);
            if (list) {
                list.push(asObject(item));
            }
            if (wipeTracker) {
                wipeTracker.setPageItems(list, itemType);
            }
            return self;
        }
        function setItems(itemType, data) {
            var i, list;
            if (!isSupportedItemType(itemType)) {
                global.log("setItems. Unsupported item type: " + itemType);
                return self;
            }
            itemType = itemType || options.defaultItemType;
            list = clearItems(itemType);
            for (i = 0; i < data.length; i++) {
                list.push(asObject(data[i]));
            }
            if (wipeTracker) {
                wipeTracker.setPageItems(list, itemType);
            }
            activateVIS();
            return self;
        }
        function isSupportedItemType(itemType) {
            for (var prop in ITEM_TYPE) {
                if (ITEM_TYPE.hasOwnProperty(prop)) {
                    if (ITEM_TYPE[prop] === itemType) {
                        return true;
                    }
                }
            }
            return false;
        }
        function clearItems(itemType) {
            itemType = itemType || options.defaultItemType;
            var list = items[itemType] = [];
            return list;
        }
        function getItem(id) {
            var type, idx, info, list;
            if (global.val.isNumber(id)) {
                idx = id;
            } else if (global.val.isString(id)) {
                info = parseEntryElementId(id);
                type = info.type;
                idx = info.idx ? info.idx - 1 : global.str.toInt(id, -1);
            } else {
                return undefined;
            }
            type = type || options.defaultItemType;
            list = getItems(type);
            if (!list || idx < 0 || idx >= list.length) {
                return undefined;
            }
            return list[idx];
        }
        function getItemClass(source, item) {
            var i, cls = item.className || "", classes = cls.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                cls = classes[i];
                if (hasLinkDefinition(source, cls)) {
                    return cls;
                }
            }
            return undefined;
        }
        function activateVIS() {
            if (global.val.isUndefined(visLoader)) {
                var vis = global.getNamespace("vis");
                if (global.val.isDefined(vis.VISLoader)) {
                    visLoader = new vis.VISLoader();
                    visLoader.load();
                }
            }
        }
        function deactivateVIS() {
            if (global.val.isDefined(visLoader)) {
                visLoader = undefined;
            }
        }
        function setParams(params, scope) {
            var merge = global.obj.deepMerge;
            params = asObject(params);
            if (scope) {
                var p = globalParams[scope] || {};
                globalParams[scope] = merge(p, params);
            } else {
                globalParams = merge(globalParams, params);
            }
            return self;
        }
        function getParams() {
            return globalParams;
        }
        function asObject(value) {
            if (global.val.isObject(value)) {
                return value;
            } else if (global.val.isString(value)) {
                return paramCodec.decode(value);
            } else {
                return {};
            }
        }
        function assignIfUndefined(dest, propName, value) {
            if (dest[propName] === undefined) {
                dest[propName] = value;
            }
        }
        function amendEntryParams(entryPar, eventInfo) {
            var pos, pageNo, absPos, entryType, contextParams, dcKey, dc, addr, dataCenters;
            pos = parseEntryElementId(eventInfo.entryId).idx;
            assignIfUndefined(entryPar, "pos", pos);
            contextParams = globalParams.context;
            if (contextParams) {
                pageNo = contextParams.pageNo;
                if (pageNo) {
                    assignIfUndefined(entryPar, "pageNo", pageNo);
                }
                entryType = eventInfo.entryType;
                entryType = entryType ? entryType + "_" : "";
                absPos = contextParams[entryType + "offset"];
                if (!absPos) {
                    absPos = 0;
                }
                absPos += pos;
                assignIfUndefined(entryPar, "absPos", absPos);
            }
            if (pos > 0) {
                --pos;
            }
            assignIfUndefined(entryPar, "idx", pos);
            addr = globalParams.hosts.entry;
            if (addr) {
                assignIfUndefined(entryPar, "host", addr);
            }
            dcKey = entryPar.ccid || entryPar.ccsd;
            if (dcKey) {
                dataCenters = global.meta.dc;
                if (dataCenters) {
                    dc = dataCenters.get(dcKey);
                    if (dc) {
                        assignIfUndefined(entryPar, "ccid", dc.id);
                        assignIfUndefined(entryPar, "ccsd", dc.sd);
                        assignIfUndefined(entryPar, "ccno", dc.no);
                        assignIfUndefined(entryPar, "domain", dc.domain);
                        assignIfUndefined(entryPar, "host", dc.addr);
                    }
                }
            }
            if (!entryPar.detailsURL) {
                entryPar.detailsURL = getShortDetailViewURL(entryPar);
            }
        }
        function trackEntryClick(event, thenProp) {
            if (wipeTracker && !isTrackingDisabled(event.event.currentTarget, event.source, event.item)) {
                wipeTracker.logAction(event.entry, event[WIPE_TRACKINGNAME], thenProp);
            }
        }
        function isTrackingDisabled(element, source, item) {
            var linkDef = getLinkDefinition(source, item), dataAttr;
            if (element) {
                dataAttr = getDataAttribute(element, WIPE_TRACKING);
                if (global.val.isDefined(dataAttr)) {
                    return dataAttr.toLowerCase() === "false" || dataAttr === "0";
                }
            }
            if (linkDef && linkDef.hasOwnProperty(WIPE_TRACKING)) {
                return linkDef[WIPE_TRACKING] === false || linkDef[WIPE_TRACKING] === 0;
            }
            return false;
        }
        function getShortDetailViewURL(entryPar) {
            var templ;
            if (!shortDetailsURLBuilder) {
                templ = options.baseURLs.detailsNoCtx || "";
                shortDetailsURLBuilder = new global.util.LinkBuilder(templ, {
                    charset: charset
                });
            }
            return shortDetailsURLBuilder.build({
                e: entryPar
            });
        }
        function preprocessUrlTemplate(url, entryData) {
            var builder, baseURLs = options.baseURLs, isPrivateEntry;
            builder = new global.util.LinkBuilder(url, {
                encode: false,
                syntax: URL_INCLUDE_MACRO_PATTERN
            });
            if (useSEOLinks(entryData)) {
                isPrivateEntry = entryData.at === 1 || entryData.at === "1";
                baseURLs = isPrivateEntry ? options.seoPrivBaseURLs : options.seoBaseURLs;
            }
            return builder.build(baseURLs);
        }
        function useSEOLinks(entryData) {
            var seoEntry;
            if (isSEOMode) {
                seoEntry = entryData.seo;
                if (global.val.isString(seoEntry)) {
                    seoEntry = global.str.toBool(seoEntry);
                }
                return seoEntry;
            }
        }
        function getLinkDefinition(source, item, entryData) {
            var linkMap, seo;
            seo = entryData && useSEOLinks(entryData);
            if (seo) {
                linkMap = options.seoLinks[source];
                if (linkMap && linkMap[item]) {
                    return linkMap[item];
                }
            }
            linkMap = options.links[source];
            if (linkMap) {
                return linkMap[item];
            }
        }
        function hasLinkDefinition(source, item) {
            return !!getLinkDefinition(source, item);
        }
        function getLink(info, entryData, item) {
            var linkDef, defaultTarget, urlTemplate, result, par, entryPar, builder, overrideUrl, overrideTarget, waName;
            linkDef = global.obj.extend({}, getLinkDefinition(info.source, info.item, entryData));
            if (global.val.isDefined(item)) {
                if (item.hasAttribute("data-href")) {
                    overrideUrl = item.getAttribute("data-href");
                    if (global.val.isDefined(linkDef)) {
                        linkDef.url = overrideUrl;
                    } else {
                        linkDef = {
                            url: overrideUrl
                        };
                    }
                }
                if (item.hasAttribute("data-target")) {
                    overrideTarget = item.getAttribute("data-target");
                    if (global.val.isDefined(linkDef)) {
                        linkDef.target = overrideTarget;
                    } else {
                        linkDef = {
                            target: overrideTarget
                        };
                    }
                }
                waName = getTrackingName(item, info, linkDef);
                if (waName) {
                    linkDef.waName = waName;
                }
            }
            if (!linkDef || !linkDef.url) {
                return;
            }
            result = global.obj.extend({}, linkDef);
            defaultTarget = options.defaultLinkTarget;
            if (defaultTarget) {
                if (!result.target && !result.popup) {
                    result.target = defaultTarget;
                }
            }
            result.url = "";
            urlTemplate = preprocessUrlTemplate(linkDef.url, entryData);
            par = global.obj.extend({}, globalParams);
            entryPar = par.e = global.obj.extend({}, entryData);
            amendEntryParams(entryPar, info);
            builder = new global.util.LinkBuilder(urlTemplate, {
                charset: charset
            });
            result.url = builder.build(par);
            return result;
        }
        function followLink(link) {
            var url = link.url;
            if (!url) {
                return;
            }
            if (options.linksEnabled) {
                if (link.target && !link.popup) {
                    link.popup = {
                        name: link.target
                    };
                }
                if (link.popup) {
                    global.ui.openWindow(url, link.popup.name, link.popup.params);
                } else {
                    win.location = url;
                }
            } else {
                global.log("Navigate -> ", link);
            }
        }
        function injectLink(item, link) {
            if (global.val.isElement(item) && link && link.url) {
                item = $(item);
                if (item.is("a")) {
                    $(item).prop("href", link.url);
                    if (link.target) {
                        $(item).prop("target", link.target);
                    }
                }
            }
        }
        function addEventHandler(key, handler) {
            var current, registeredHandlers = options.eventHandlers;
            if (key && handler) {
                key = String(key);
                current = registeredHandlers[key];
                if (!current) {
                    current = handler;
                } else {
                    current = [].concat(current, handler);
                }
                registeredHandlers[key] = current;
            }
            return self;
        }
        function removeEventHandler(key, handler) {
            var current, handlers = options.eventHandlers;
            current = handlers[key];
            if (global.val.isUndefined(handler)) {
                delete handlers[key];
            } else if (global.val.isFunction(current)) {
                if (String(current) === String(handler)) {
                    delete handlers[key];
                }
            } else if (global.val.isArray(current)) {
                for (var i = 0; i < current.length; i++) {
                    if (String(current[i]) === String(handler)) {
                        current.splice(i, 1);
                    }
                }
            }
            return self;
        }
        function getEventHandlers(event, info) {
            var result = [], eventTypePrefix, eventId, h, handlers = options.eventHandlers;
            eventTypePrefix = event.type + ":";
            eventId = eventTypePrefix;
            h = handlers[eventTypePrefix + "*"];
            if (h) {
                result.push(h);
            }
            eventId += info.source;
            h = handlers[eventId];
            if (h) {
                result.push(h);
            }
            eventId += "." + info.item;
            h = handlers[eventId];
            if (h) {
                result.push(h);
            }
            eventId += "." + info.entryId;
            h = handlers[eventId];
            if (h) {
                result.push(h);
            }
            h = handlers[eventTypePrefix + "*." + info.entryId];
            if (h) {
                result.push(h);
            }
            result = global.arr.flatten(result);
            return result.reverse();
        }
        function handleItemEvent(event, info) {
            var entryData, parsedId, item, itemClass;
            if (!info || !info.item) {
                return;
            }
            item = info.item;
            if (global.val.isElement(item)) {
                itemClass = getItemClass(info.source, item);
                if (!info.entryId) {
                    info.entryId = getEntryId(item);
                }
                info.item = itemClass || UNKNOWN_CLASS;
            }
            if (!info.entryId) {
                return;
            }
            parsedId = parseEntryElementId(info.entryId);
            if (parsedId) {
                info.entryType = parsedId.type;
            }
            entryData = getItem(info.entryId);
            if (!entryData) {
                return;
            }
            switch (event.type) {
              case CONTEXTMENU_EVENT:
              case CLICK_EVENT:
                handleItemClickEvent(event, info, item, entryData);
                break;

              case MOUSEOVER_EVENT:
                handleItemMouseEvent(event, info, item, entryData);
                break;

              case MOUSEOUT_EVENT:
                handleItemMouseEvent(event, info, item, entryData);
                break;

              case MOUSEENTER_EVENT:
                handleItemMouseEvent(event, info, item, entryData);
                break;

              case MOUSELEAVE_EVENT:
                handleItemMouseEvent(event, info, item, entryData);
                break;
            }
        }
        function getUrl(element) {
            var itemClass, entryData, info = {
                source: SOURCE_HIT
            }, $element = $(element), link;
            if ($element.length < 0) {
                return;
            }
            itemClass = getItemClass(info.source, element);
            info.item = itemClass || UNKNOWN_CLASS;
            info.entryId = getEntryId(element);
            entryData = getItem(info.entryId);
            link = getLink(info, entryData, element);
            return link.url;
        }
        function handleItemMouseEvent(event, info, item, entryData) {
            var i, entryEvent, handlers, cancel = false;
            handlers = getEventHandlers(event, info);
            entryEvent = global.obj.extend({}, info);
            entryEvent.event = event;
            entryEvent.entry = entryData;
            entryEvent.params = globalParams;
            if (handlers.length > 0) {
                for (i = 0; i < handlers.length; i++) {
                    cancel = handlers[i](entryEvent) === false;
                    if (cancel) {
                        break;
                    }
                }
            }
            event.preventDefault();
            event.stopPropagation();
        }
        function handleItemClickEvent(event, info, item, entryData) {
            var link, i, entryEvent = {}, handlers, cancel, preventDefaultAction, doFollowLink = false;
            link = getLink(info, entryData, item);
            if (event.type === CONTEXTMENU_EVENT) {
                injectLink(item, link);
                event.stopPropagation();
                return;
            }
            handlers = getEventHandlers(event, info);
            entryEvent = getEntryEvent(info, event, entryData, link);
            cancel = false;
            if (handlers.length > 0) {
                for (i = 0; i < handlers.length; i++) {
                    cancel = handlers[i](entryEvent) === false;
                    if (cancel) {
                        break;
                    }
                }
            } else {
                if (!options.linksEnabled) {
                    global.log(entryEvent);
                }
            }
            preventDefaultAction = cancel || event.isDefaultPrevented();
            event.preventDefault();
            event.stopPropagation();
            doFollowLink = link && !cancel && !preventDefaultAction;
            if (wipeTracker) {
                if (doFollowLink) {
                    if (link.popup || link.target && link.target === "_blank") {
                        trackEntryClick(entryEvent);
                        followLink(link);
                    } else {
                        trackEntryClick(entryEvent, function() {
                            followLink(link);
                        });
                    }
                } else {
                    trackEntryClick(entryEvent);
                }
            } else {
                if (doFollowLink) {
                    followLink(link);
                }
            }
        }
        function getEntryEvent(info, event, entryData, link) {
            var entryEvent = global.obj.extend({}, info);
            entryEvent.event = event;
            entryEvent.entry = entryData;
            entryEvent.params = globalParams;
            if (link) {
                entryEvent.link = link;
            }
            entryEvent[WIPE_TRACKINGNAME] = getTrackingName(event.currentTarget, info, link);
            return entryEvent;
        }
        function getTrackingName(currentTarget, info, link) {
            var item = info.item, wipeTrackingName = getDataAttribute(currentTarget, WIPE_TRACKINGNAME);
            if (global.val.isUndefined(wipeTrackingName) && link && link.hasOwnProperty(WIPE_TRACKINGNAME)) {
                wipeTrackingName = link[WIPE_TRACKINGNAME];
            }
            if ((item === UNKNOWN_CLASS || !hasLinkDefinition(info.source, info.item)) && global.val.isUndefined(wipeTrackingName)) {
                item = getAutoItemName(currentTarget);
            }
            return wipeTrackingName || info.entryType + ":" + info.source + ":" + item;
        }
        function getAutoItemName(item) {
            var result, cls = item.className || "", classes = cls.split(/\s+/);
            result = classes.join(",");
            return result === "" ? UNKNOWN_CLASS + AUTO_POSTFIX : result + AUTO_POSTFIX;
        }
        function getDataAttribute(element, name) {
            if (element) {
                return element.dataset[name];
            }
        }
        function getHiddenEntries(itemType, selector) {
            var entries, entry, entryData, domId, result = [];
            if (!isSupportedItemType(itemType)) {
                throw new Error("Unsupported item type: " + itemType);
            }
            selector = global.val.isUndefined(selector) ? '[id^="' + itemType + '_"]' : selector;
            try {
                entries = doc.querySelectorAll(selector);
                if (entries.length <= 0) {
                    global.trace("[WARNING] No entries found. Query selector: " + selector);
                }
                for (var i = 0; i < entries.length; i++) {
                    entry = entries[i];
                    if (!global.util.DOM.isVisible(entry)) {
                        domId = entry.id;
                        entryData = getItem(domId);
                        result.push(new EntryInfo(domId, entry, entryData));
                    }
                }
            } catch (e) {
                global.trace(e);
            }
            return result;
        }
        function hasHiddenEntries(itemType, selector) {
            return getHiddenEntries(itemType, selector).length > 0;
        }
        function trackHiddenEntries(itemType, selector) {
            if (wipeTracker) {
                var entries = getHiddenEntries(itemType, selector);
                if (entries.length > 0) {
                    try {
                        return wipeTracker.setCustomPageAttr(options.wipe.attr.hiddenEntries, entries.length);
                    } catch (e) {
                        global.trace(e);
                    }
                }
            }
        }
        function addColumnMinHeight() {
            var sourceColumn, targetColumn, opts = options.entryContainerMinHeight;
            if (!opts || !opts.enabled) {
                return;
            }
            sourceColumn = $(opts.source);
            targetColumn = $(opts.target);
            if (!sourceColumn.length || !targetColumn.length) {
                global.trace("Failed to get elements. addColumnMinHeight aborted.", opts);
                return;
            }
            $(targetColumn[0]).css("min-height", $(sourceColumn[0]).height() + opts.addHeight);
        }
        function init() {
            var dc, wipeOpt;
            initialOptions = initialOptions || {};
            setOptions(initialOptions);
            globalParams.hosts = options.hosts;
            global.obj.extend(options.seoBaseURLs, options.baseURLs);
            isSEOMode = options.hitlistType === "seo";
            dc = options.currentDataCenter;
            if (dc && !globalParams.hosts.meinoe) {
                globalParams.hosts.meinoe = dc.moeaddr;
            }
            charset = options.charset;
            paramCodec = new global.util.QueryStringCodec(charset);
            wipeOpt = options.wipe;
            if (wipeOpt) {
                if (wipeOpt.enabled && !global.util.AnalyzerCheck.isValidAnalyzer(wipeOpt)) {
                    global.error(global.util.AnalyzerCheck.getNoAnalyzerErrorText(), wipeOpt);
                } else {
                    wipeTracker = new global.wipe.Tracker(wipeOpt);
                }
            }
            ponyfillHandler = new global.legacy.PonyfillHandler(options.ponyfill);
            global.ui.onDomReady(function() {
                addColumnMinHeight();
                entryLinks = new EntryLinks(options);
                entryLinks.onClick = handleItemEvent;
                entryLinks.onCtxMenu = handleItemEvent;
                entryLinks.onMouseOver = handleItemEvent;
                entryLinks.onMouseOut = handleItemEvent;
                entryLinks.onMouseEnter = handleItemEvent;
                entryLinks.onMouseLeave = handleItemEvent;
                entryLinks.bind(options.entryContainers);
                ponyfillHandler.activateCssVars();
            });
        }
        init();
        this.getOptions = getOptions;
        this.setOptions = setOptions;
        this.addItem = addItem;
        this.setItems = setItems;
        this.getItems = getItems;
        this.clearItems = clearItems;
        this.setParams = setParams;
        this.getParams = getParams;
        this.addEventHandler = addEventHandler;
        this.removeEventHandler = removeEventHandler;
        this.followLink = followLink;
        this.getUrl = getUrl;
        this.deactivateVIS = deactivateVIS;
        this.hasHiddenEntries = hasHiddenEntries;
        this.getHiddenEntries = getHiddenEntries;
        this.trackHiddenEntries = trackHiddenEntries;
    }
    function EntryHandlerFactory() {
        function newHandler(options) {
            var handler = new EntryHandler(options);
            entryHandlerList.push(handler);
            return handler;
        }
        function getHandlers() {
            return entryHandlerList;
        }
        this.newHandler = newHandler;
        this.getHandlers = getHandlers;
    }
    function EntryInfo(domId, element, entryData) {
        this.domId = domId;
        this.element = element;
        this.entryData = entryData;
    }
    function EntryLinks(options) {
        var self = this, opts, DEFAULT_OPTIONS = {
            linkSelectors: {
                entry: []
            }
        }, HITLINKS_SELECTOR = "div.hit a", FREECALL_ICON_CLASS = "freecall_icon", HITLINKS_FREECALL_ICON = "div.hit i." + FREECALL_ICON_CLASS, RESTAURANT_SUB_SELECTOR = "div.hit div.left a.hitlnk_restaurant", ALL_HIT_FUNCTIONS_SELECTOR = [ RESTAURANT_SUB_SELECTOR ].join(",");
        function handleClick(source, item, event) {
            var eventInfo, callback;
            eventInfo = {
                source: source,
                item: item
            };
            if (event.type === CONTEXTMENU_EVENT) {
                callback = self.onCtxMenu;
            } else {
                callback = self.onClick;
            }
            if (callback) {
                callback.call(this, event, eventInfo);
            } else {
                global.log(eventInfo);
            }
        }
        function handleMouseOver(source, item, event) {
            var eventInfo, callback;
            eventInfo = {
                source: source,
                item: item
            };
            callback = self.onMouseOver;
            if (callback) {
                callback.call(this, event, eventInfo);
            } else {
                global.log(eventInfo);
            }
        }
        function handleMouseOut(source, item, event) {
            var eventInfo, callback;
            eventInfo = {
                source: source,
                item: item
            };
            callback = self.onMouseOut;
            if (callback) {
                callback.call(this, event, eventInfo);
            } else {
                global.log(eventInfo);
            }
        }
        function handleMouseEnter(source, item, event) {
            var eventInfo, callback;
            eventInfo = {
                source: source,
                item: item
            };
            callback = self.onMouseEnter;
            if (callback) {
                callback.call(this, event, eventInfo);
            } else {
                global.log(eventInfo);
            }
        }
        function handleMouseLeave(source, item, event) {
            var eventInfo, callback;
            eventInfo = {
                source: source,
                item: item
            };
            callback = self.onMouseLeave;
            if (callback) {
                callback.call(this, event, eventInfo);
            } else {
                global.log(eventInfo);
            }
        }
        function hitFunctionClick(event) {
            handleClick(SOURCE_HIT, this, event);
        }
        function hitLinkClick(event) {
            handleClick(SOURCE_HIT, this, event);
        }
        function hitLinkMouseOver(event) {
            handleMouseOver(SOURCE_HIT, this, event);
        }
        function hitLinkMouseOut(event) {
            handleMouseOut(SOURCE_HIT, this, event);
        }
        function hitLinkMouseEnter(event) {
            handleMouseEnter(SOURCE_HIT, this, event);
        }
        function hitLinkMouseLeave(event) {
            handleMouseLeave(SOURCE_HIT, this, event);
        }
        function bindClickEvents(parent, selector, handler) {
            parent.off(CLICK_AND_CONTEXTMENU_EVENTS, selector).on(CLICK_AND_CONTEXTMENU_EVENTS, selector, handler);
        }
        function unbindClickEvents(parent, selector) {
            parent.off(CLICK_AND_CONTEXTMENU_EVENTS, selector);
        }
        function bindMouseOverEvents(parent, selector, handler) {
            parent.off(MOUSEOVER_EVENT, selector).on(MOUSEOVER_EVENT, selector, handler);
        }
        function unbindMouseOverEvents(parent, selector) {
            parent.off(MOUSEOVER_EVENT, selector);
        }
        function bindMouseOutEvents(parent, selector, handler) {
            parent.off(MOUSEOUT_EVENT, selector).on(MOUSEOUT_EVENT, selector, handler);
        }
        function unbindMouseOutEvents(parent, selector) {
            parent.off(MOUSEOUT_EVENT, selector);
        }
        function bindMouseEnterEvents(parent, selector, handler) {
            parent.off(MOUSEENTER_EVENT, selector).on(MOUSEENTER_EVENT, selector, handler);
        }
        function unbindMouseEnterEvents(parent, selector) {
            parent.off(MOUSEENTER_EVENT, selector);
        }
        function bindMouseLeaveEvents(parent, selector, handler) {
            parent.off(MOUSELEAVE_EVENT, selector).on(MOUSELEAVE_EVENT, selector, handler);
        }
        function unbindMouseLeaveEvents(parent, selector) {
            parent.off(MOUSELEAVE_EVENT, selector);
        }
        function bind(parentEl) {
            var jqParent = $(parentEl);
            bindClickEvents(jqParent, HITLINKS_SELECTOR, hitLinkClick);
            bindClickEvents(jqParent, ALL_HIT_FUNCTIONS_SELECTOR, hitFunctionClick);
            bindMouseOverEvents(jqParent, HITLINKS_SELECTOR, hitLinkMouseOver);
            bindMouseOutEvents(jqParent, HITLINKS_SELECTOR, hitLinkMouseOut);
            bindMouseEnterEvents(jqParent, HITLINKS_SELECTOR, hitLinkMouseEnter);
            bindMouseLeaveEvents(jqParent, HITLINKS_SELECTOR, hitLinkMouseLeave);
        }
        function unbind(parentEl) {
            var jqParent = $(parentEl);
            unbindClickEvents(jqParent, HITLINKS_SELECTOR);
            unbindClickEvents(jqParent, ALL_HIT_FUNCTIONS_SELECTOR);
            unbindClickEvents(jqParent, HITLINKS_FREECALL_ICON);
            unbindMouseOverEvents(jqParent, HITLINKS_SELECTOR);
            unbindMouseOutEvents(jqParent, HITLINKS_SELECTOR);
            unbindMouseEnterEvents(jqParent, HITLINKS_SELECTOR);
            unbindMouseLeaveEvents(jqParent, HITLINKS_SELECTOR);
        }
        function init() {
            var selectors = [ HITLINKS_SELECTOR ], additionalSelectors;
            opts = global.obj.deepMerge(DEFAULT_OPTIONS, options || {});
            additionalSelectors = global.obj.toArray(options.linkSelectors.entry);
            if (!global.val.isArray(additionalSelectors)) {
                additionalSelectors = [];
            }
            selectors = selectors.concat(additionalSelectors);
            HITLINKS_SELECTOR = selectors.join(",");
        }
        init();
        this.bind = bind;
        this.unbind = unbind;
        this.onClick = undefined;
        this.onCtxMenu = undefined;
        this.onMouseOver = undefined;
        this.onMouseOut = undefined;
        this.onMouseEnter = undefined;
        this.onMouseLeave = undefined;
    }
    hl.entryHandlers = new EntryHandlerFactory();
    hl.newEntryHandler = hl.entryHandlers.newHandler;
    hl.ITEMTYPE = ITEM_TYPE;
})($oe$);

/*!
 * @preserve
 *  
 * vis.core-lib.loader.js
 *
 * Copyright (C) 2015 TENSQUARE gmbh. All rights reserved.
 * www.tensquare.de
 *
 * Die Inhalte dieser Datei sind urheberrechtlich geschützt. Sie dürfen
 * weder ganz noch in Teilen vervielfältigt, verbreitet oder öffentlich
 * zugänglich gemacht werden. Jegliche Nutzung, sowohl zu privaten als
 * auch zu kommerziellen Zwecken, bedarf der schriftlichen Genehmigung
 * der TENSQUARE gmbh.
 */
if (typeof $tb$ === "undefined" && typeof $oe$ === "undefined") {
    throw new Error("Core libs missing");
}

var $corelib$ = typeof $tb$ === "undefined" ? $oe$ : $tb$;

(function(global, win, doc) {
    "use strict";
    var vis = global.getNamespace("vis");
    function VISLoader() {
        var DEFAULTOPTIONS = {
            script: {
                id: "__vis_loader__",
                source: null
            },
            cookie: {
                name: "VISWS_STATE"
            }
        }, options;
        function init() {
            options = global.options && global.options.vis ? global.obj.deepMerge({}, DEFAULTOPTIONS, global.options.vis.DEFAULT) : {};
        }
        function check() {
            var cookie;
            if (!global.val.isString(options.script.source) || options.script.source.trim() === "" || doc.getElementById(options.script.id) !== null) {
                return false;
            }
            cookie = getCookie(options.cookie.name);
            if (global.val.isDefined(cookie)) {
                try {
                    return cookie.active || false;
                } catch (ex) {
                    global.trace("cookie check failed", ex);
                }
            }
            return false;
        }
        function getCookie(name, decodeBase64) {
            var cookie;
            decodeBase64 = global.val.isBoolean(decodeBase64) ? decodeBase64 : true;
            try {
                cookie = getCookieValue(name);
                if (global.val.isUndefined(cookie)) {
                    return;
                }
                if (cookie.length > 1) {
                    cookie = unquote(cookie);
                }
                if (decodeBase64) {
                    cookie = win.atob(cookie);
                }
                cookie = JSON.parse(cookie);
            } catch (ex) {
                global.trace("Error getCookie", ex);
            }
            return cookie;
        }
        function getCookieValue(name) {
            return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(name).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || undefined;
        }
        function unquote(str, quoteChar) {
            var qs = quoteChar || '"';
            if (str[0] === qs && str[str.length - 1] === qs) {
                return str.slice(1, str.length - 1);
            } else {
                return str;
            }
        }
        this.load = function() {
            if (!check()) {
                return;
            }
            var scriptTag = doc.createElement("script");
            scriptTag.type = "text/javascript";
            scriptTag.src = options.script.source;
            scriptTag.setAttribute("id", options.script.id);
            appendTag(scriptTag, onLoadVISLoader);
        };
        function onLoadVISLoader() {
            if (win.$vv$ && global.val.isFunction(win.$vv$.activateVIS)) {
                win.$vv$.activateVIS();
            }
        }
        function appendTag(tag, onLoad) {
            if (tag.addEventListener) {
                tag.addEventListener("load", onLoad, false);
            } else if (tag.readyState) {
                tag.onreadystatechange = onLoad;
            }
            doc.body.appendChild(tag);
        }
        init();
    }
    vis.VISLoader = VISLoader;
})($corelib$, this, document);